// Calling Supabase Edge Functions with consistent, user-safe error handling.

import { FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase/client';
import { UserFacingError, toUserMessage } from '@/lib/errors';

export async function invokeFunction<T>(name: string, body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke<T>(name, { body });
  if (error) {
    if (error instanceof FunctionsHttpError) {
      let payload: { error?: { code?: string; message?: string } } | null = null;
      try {
        payload = await error.context.json();
      } catch {
        /* non-JSON error */
      }
      const code = payload?.error?.code ?? 'error';
      // Edge Functions only return messages written for users (see _shared/http.ts).
      throw new UserFacingError(payload?.error?.message ?? toUserMessage(error), code);
    }
    throw new UserFacingError(toUserMessage(error), 'network');
  }
  return data as T;
}
